import './Settings.css';

export default function Settings() {
  // Get session from localStorage
  const session = JSON.parse(localStorage.getItem('poly_session') || '{}');

  return (
    <div className="settings-page animate-in">
      {/* Profile Section */}
      <section className="settings-section">
        <h2 className="section-title">Profile</h2>
        <div className="card">
          <div className="profile-info">
            <div className="profile-avatar">
              {session.displayName?.[0] || 'U'}
            </div>
            <div className="profile-details">
              <h3 className="profile-name">{session.displayName || 'User'}</h3>
              <p className="profile-wallet">{session.wallet || 'Not connected'}</p>
              <div className="profile-roles">
                {(session.roles || []).map((role: string) => (
                  <span key={role} className="badge badge-primary">{role}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Security Section */}
      <section className="settings-section">
        <h2 className="section-title">Security</h2>
        <div className="card">
          <div className="settings-list">
            <div className="settings-item">
              <div className="settings-item-info">
                <h4>Guardians</h4>
                <p>Manage your recovery guardians</p>
              </div>
              <button className="btn btn-secondary">Manage</button>
            </div>
            
            <div className="settings-item">
              <div className="settings-item-info">
                <h4>Two-Factor Authentication</h4>
                <p>Additional security for sensitive actions</p>
              </div>
              <span className="badge badge-success">Enabled</span>
            </div>
            
            <div className="settings-item">
              <div className="settings-item-info">
                <h4>Session Timeout</h4>
                <p>Automatically sign out after inactivity</p>
              </div>
              <select className="settings-select">
                <option>15 minutes</option>
                <option>30 minutes</option>
                <option>1 hour</option>
                <option>4 hours</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Data Section */}
      <section className="settings-section">
        <h2 className="section-title">Data</h2>
        <div className="card">
          <div className="settings-list">
            <div className="settings-item">
              <div className="settings-item-info">
                <h4>Export Data</h4>
                <p>Download an encrypted backup of your data</p>
              </div>
              <button className="btn btn-secondary">Export</button>
            </div>
            
            <div className="settings-item">
              <div className="settings-item-info">
                <h4>Clear Local Cache</h4>
                <p>Remove cached data from this browser</p>
              </div>
              <button className="btn btn-danger">Clear</button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="settings-section">
        <h2 className="section-title">About</h2>
        <div className="card">
          <div className="about-info">
            <p><strong>Poly Messenger Console</strong></p>
            <p>Version 0.1.0</p>
            <p className="text-muted">Quantum-secure account management</p>
          </div>
        </div>
      </section>
    </div>
  );
}
